import { PortableText, PortableTextComponentProps } from '@portabletext/react'
import type { PortableTextBlock } from '@portabletext/types'
import Image from 'next/image'
import Link from 'next/link'

import type { SanityImage } from '@/constant/types'
import { cn } from '@/lib/utils'
import { urlForImage } from '@/sanity/lib/image'

interface RichTextProps {
  content: PortableTextBlock[]
  className?: string
}

export const RichTextComponents = {
  types: {
    image: ({ value }: { value: SanityImage }) => {
      const imageBuilder = urlForImage(value)
      return (
        <div className=''>
          <Image
            className='h-auto w-full'
            src={imageBuilder ? imageBuilder.width(1440)?.url() : ''}
            width={value?.asset?.metadata?.dimensions?.width}
            height={value?.asset?.metadata?.dimensions?.height}
            alt={value?.alt || ''}
            placeholder='blur'
            blurDataURL={value?.asset?.metadata?.lqip}
          />
        </div>
      )
    },
    // hr: () => <div><div className="hr block appearance-none h-0 border-solid border-blue-light border-b border-t-0 my-12 md:my-16" /></div>
  },
  block: {
    normal: ({ children }: PortableTextComponentProps<PortableTextBlock>) => (
      <p className='mb-4 last:mb-0'>{children}</p>
    ),
    small: ({ children }: PortableTextComponentProps<PortableTextBlock>) => (
      <p className='mb-4 text-sm'>
        <small style={{ fontSize: 'inherit' }} className=''>
          {children}
        </small>
      </p>
    ),
    blockquote: ({
      children,
    }: PortableTextComponentProps<PortableTextBlock>) => (
      <blockquote className='relative pl-[1.5em]'>{children}</blockquote>
    ),
  },
  marks: {
    link: ({
      children,
      value,
    }: {
      children: React.ReactNode
      value?: { url: string }
    }) => {
      const target = !value?.url?.startsWith('/') ? '_blank' : '_self'
      const rel = !value?.url?.startsWith('/') ? 'noreferrer noopener' : ''
      const url = value?.url
      if (!url) return null
      return target === '_blank' ? (
        <a
          href={url}
          className='hover:text-blue text-current underline'
          rel={rel}
          target={target}
        >
          {children}
        </a>
      ) : (
        <Link
          href={value?.url}
          className='hover:text-blue text-current underline'
          rel={rel}
          target={target}
        >
          {children}
        </Link>
      )
    },
  },
}

export default function RichText({ content, className }: RichTextProps) {
  return (
    <div className={cn('text--block', className)}>
      <PortableText value={content} components={RichTextComponents} />
    </div>
  )
}
